import { Box, Button, Typography } from "@mui/material";

const textButtonSx = { textTransform: "none" };

export const QueueSelectionControl = ({
  label,
  onSelectAll,
  allSelected,
  selecting,
  error,
  clearLabel,
  onClear,
  selectedCount,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "baseline",
        columnGap: 1.5,
        rowGap: 0.5,
      }}
    >
      <Button
        variant="text"
        size="small"
        disabled={selecting || allSelected}
        onClick={onSelectAll}
        sx={textButtonSx}
      >
        {selecting ? "Selecting…" : label}
      </Button>
      {selectedCount > 0 ? (
        <Button
          variant="text"
          size="small"
          disabled={selecting}
          onClick={onClear}
          sx={textButtonSx}
        >
          {clearLabel}
        </Button>
      ) : null}
      {error ? (
        <Typography variant="body2" color="error.main">
          {error}
        </Typography>
      ) : null}
    </Box>
  );
};

export const BulkSelectionNotice = ({ notice, onClose }) => {
  if (!notice) return null;
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "baseline",
        columnGap: 1.5,
        mx: 2,
        mb: 1,
        px: 2,
        py: 1,
        bgcolor: "action.hover",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.primary">
        {notice}
      </Typography>
      <Button
        size="small"
        onClick={onClose}
        sx={{ minWidth: 0, px: 0.5, py: 0, textTransform: "none" }}
      >
        Dismiss
      </Button>
    </Box>
  );
};
